var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForwardArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "more",
    clipPath: "url(#forwardArrow)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.0365 7.22218C13.718 7.51842 13.718 7.99696 14.0365 8.2932L17.2051 11.2404H4.81664C4.36749 11.2404 4 11.5822 4 12C4 12.4178 4.36749 12.7596 4.81664 12.7596H17.2132L14.0447 15.7068C13.7262 16.003 13.7262 16.4816 14.0447 16.7778C14.3631 17.0741 14.8776 17.0741 15.1961 16.7778L19.7611 12.5317C20.0796 12.2355 20.0796 11.7569 19.7611 11.4607L15.188 7.22218C14.8776 6.92594 14.355 6.92594 14.0365 7.22218Z",
    fill: "#B4B5B8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "forwardArrow"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForwardArrow);
export default __webpack_public_path__ + "static/media/forwardArrow.2369b71aaa8e3cbcd331a36338dc3916.svg";
export { ForwardRef as ReactComponent };